import styled from 'styled-components';

/* Mixins */
import { WebFontCallout1, WebFontBody1 } from 'styles/Mixins';

const TRANSITION_TIME = '0.3s';

export const CollapsibleContainer = styled.div`
  width: 100%;
`;

export const CollapsibleTitleSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 16px 0;
`;

export const CollapsibleTitle = styled.div`
  ${WebFontCallout1};
  color: ${({ theme }) => theme.Grey1};
`;

export const CollapsibleBodyWrapper = styled.div<{ sectionBodyHeight: number }>`
  height: ${({ sectionBodyHeight }) => `${sectionBodyHeight}px`};
  transition: height ${TRANSITION_TIME};
  overflow: hidden;
`;

export const CollapsibleBody = styled.div`
  width: 100%;
  padding-bottom: 12px;
`;

export const ActionText = styled.div`
  ${WebFontBody1};
  cursor: pointer;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.primaryColor};
`;
